import { render, staticRenderFns } from "./QuoteHistoryModal.vue?vue&type=template&id=8f9d515e&scoped=true&"
import script from "./QuoteHistoryModal.vue?vue&type=script&lang=js&"
export * from "./QuoteHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./QuoteHistoryModal.vue?vue&type=style&index=0&id=8f9d515e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9d515e",
  null
  
)

export default component.exports